import { ResolveProblemList } from '@components/buzzkuri/model/program/ResolveProblemList'
import { ProgramDescriptionAccordion } from '@components/buzzkuri/shared/uiParts/accordion/ProgramDescription'
import { BREAKPOINTS } from '@constants/common'
import { WindowSizeContext } from '@context/WindowSize/Context'
import { ResolveProblem } from '@type/buzzkuri/programs-categor'
import React, { useContext } from 'react'

type Props = {
  resolveProblems: ResolveProblem[]
  iconPath: string
}

export const ResolveProblems = ({
  resolveProblems,
  iconPath,
}: Props): JSX.Element => {
  const winSize = useContext(WindowSizeContext)

  return (
    <div className="lg:w-[65.2vw]">
      <ProgramDescriptionAccordion
        title={
          winSize?.width > BREAKPOINTS.laptop
            ? 'こんな悩みや課題をお持ちの方におすすめ'
            : 'こんな悩みや課題を\nお持ちの方におすすめ'
        }
      >
        <ResolveProblemList {...{ resolveProblems, iconPath }} />
      </ProgramDescriptionAccordion>
    </div>
  )
}
